/* eslint-disable import/prefer-default-export */
import _reduce from 'lodash/reduce'
import { useSelector } from 'react-redux'
import { selectStaticTextByKey } from './selectors'

/**
 * @param {String}  staticTextKey
 * @return {useTranslation~translate}
 */
export function useTranslation (staticTextKey) {
  const staticText = useSelector(selectStaticTextByKey(staticTextKey))
  /**
   * @param {String} literal
   * @returns {String} translated literal
   */
  const translate = (literal, data = {}) => {
    const text = staticText.get(literal) || ''
    if (!data) return text
    return _reduce(data, (out, value, key) => (
      // eslint-disable-next-line prefer-template
      out.replace(new RegExp('\\$\\{\\s?' + key + '\\s?\\}', 'i'), value)
    ), text)
  }
  return translate
}
